import stressFeaturesGradients from '@/app/[locale]/stress/_data/stressFeaturesGradients';
import getStressFeatures from '@/app/[locale]/stress/_utils/getStressFeatures';
import LandingPageFeatures from '@/app/components/LandingPage/LandingPageFeatures';
import useTrustedAdvisorRollout from '@/app/hooks/useTrustedAdvisorRollout';

const StressFeatures = () => {
  // TODO: GROW-2946 Clean up trusted advisor rollout
  const isTrustedAdvisorEnabled = useTrustedAdvisorRollout();

  const stressFeatures = getStressFeatures(isTrustedAdvisorEnabled);

  return (
    <LandingPageFeatures
      data-cy="stress-features"
      eyebrow="explore_features"
      features={stressFeatures}
      imageGradientBg={{
        className: 'bg-[#605570]',
        gradients: stressFeaturesGradients,
      }}
      textColor="purple-700"
    />
  );
};
export default StressFeatures;
